
export const cashConfig = `<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （1）活力人生活动时间为2024年6月17日至2025年6月17日；活动范围为所有进入本游戏的用户；本次活动名额仅限前100000名用户。本游戏预计提现最高金额为1000元。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （2）请您理解并同意产品内分红及现金发放数量随机；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （3）活力人生展示多个提现比例，使用每个提现比例有自己的使用要求，用户达到后方可按对应提现比例进行提现。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （4）150、200元提现活动规则需要依次满足三个阶段的条件，方可进行
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    活动规则，各条件如下：
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    a、 150元活动规则：第一阶段条件为现金余额150元；第二阶段条件累计连续签到180天；第三阶段玩家等级段位达到26级；每天10个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    b、 200元活动规则：第一阶段条件为现金余额200元；第二阶段条件累计连续签到300天；第三阶段条件玩家等级段位达到30级；每天5个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
     5）【好友提现】提现规则： 部分提现需要认证账号无风险，若有风险需要邀请好友验证辅助提现。邀请第一个新用户最高可得5元奖励，第二个最高可得10元奖励，第三个最高可得15元奖励。被邀请用户成功提现并完成3个订单即可成为有效好友。邀请好友提现收益由被邀请有效好友的红包收益决定，被邀请有效好友每次观看广告获得的红包会以10%的比例额外奖励给邀请方。邀请好友收益满0.3元即可提现，每天上限提现10次，无其他提现要求。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （6）产品内活跃等级共有30级，观看一定次数的视频广告即可升级，无其他要求，等级与对应的观看次数对应关系如下（前为观看次数，后为对应等级数，等级间以逗号分割）： "0":1级,"2":2级,"3":3级,"4":4级,"5":5级,"6":6级,"7":7级,"8":8级,"9":9级,"10":10级,"15":11级,"20":12级,"25":13级,"30":14级,"40":15级,"50":16级,"60":17级,"70":18级,"80":19级,"100":20级,"120":21级,"140":22级,"160":23级,"180":24级,"200":25级,"300":26级,"500":27级,"800":28级,"1000":29级,"300000":30级 。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （7）由于微信支付需要实名制，非实名用户账号无法支持提现，请务必将提现的微信号进行实名认证，因未实名导致的提现失败不进行退款；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （8）单笔提现金额最低0.1元，最高金额为1000元。每日最多10次提现，除下述提及的档位提现要求以外，无注册时长条件，无在线时长条件，无提现间隔条件，无等级条件要求，无邀请好友，总体提现次数不限。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （9）上述“任务”类型或者“档位”类型的提现项，最大单笔金额为最高任务或者最大档位对应显示的金额，每个任务或者档位达到提示的要求即可提现，无其他要求，不同用户花费的时长也不一样。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （10）不同用户的广告收益不同，广告结束后会根据用户的广告价值计算和发放，不同用户达到对应档位的余额，时间也不一致。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （11）活力人生保留对本产品的最终解释权，若发现用户有外挂等恶意作弊行为，一律封禁账号并扣除账户所有余额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
     
    </span>
</p>`;
